<template>
  <div class="footer">
    <div v-if="!$store.state.isIot1 && !$store.state.isIot3" class="footer-copyright">
      <p class="m-right">
        ©{{ $t('icp.company') }}
      </p>
      <div class="footer-links">
        <div class="footer-links">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            class="m-right"
          >{{ $t('icp.icpNo') }}</a>
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050902100527"
            target="_blank"
          >
            <img
              class="beian1"
              src="~@/assets/img/footer-beian1.png"
              alt=""
            >{{ $t('icp.networkSecurity') }}
          </a>
          <!-- <a
            href="http://218.242.124.22:8081/businessCheck/verifKey.do?showType=extShow&amp;serial=9031000020180727092259000002729632-SAIC_SHOW_310000-20181123130300138818&amp;signData=MEUCIQDuPXuY4RHy0QnVpEiDo1njdBI0jIONiTZmecv2RxNwIgIgELsOGMVXW0+9X3N7FS95iHi/cQkMqXxLgpzugEHCLEM="
            target="_blank"
          ><img
            class="beian2"
            src="~@/assets/img/footer-beian2.png"
            alt=""
          ></a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      
    }
  }
}
</script>

<style lang="scss" scoped>
.footer{
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 25px;
  font-size: 22px;
  bottom: 0;
  padding-top: 4px;
  left: 150px;
  transition: left 0.3s ease-in-out !important;
}
.beian1{
  width: 5px;
}
.beian2{
  width: 5px;
}
.footer-copyright{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #999;
  a{
    color: #999;
    display: flex;
    align-items: center;

  }
  a:hover{
    color: #999;
  }
  .m-right{
    margin-right: 30px;
  }
}
.footer-links{
  display: flex;
  font-size: 12px;
}
</style>
